import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import TooltipCommon from 'components/common/TooltipCommon';
import TooltipCommonMobile from 'components/common/TooltipCommon/mobile';
import { getFullNameReceiver } from 'components/FormEditReceiver/func';
import {
  BUSINESS_OF_RECEIVER_TYPE,
  DESKTOP_MIN_WIDTH,
  EDIT_RECEIVER_FISTNAME_NAME,
  EDIT_RECEIVER_FULLNAME_NAME,
  EDIT_RECEIVER_GENDER_NAME,
  EDIT_RECEIVER_LASTNAME_NAME,
  EDIT_RECEIVER_MOBILE_NAME,
  EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD,
  EDIT_RECEIVER_PHONE_NAME,
  EDIT_RECEIVER_RELATIONSHIP_NAME,
  EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME,
  METHOD_BANK,
} from 'constants';
import { Fade } from 'helpers/animation';
import useReceiver from 'hooks/receiver/useReceiver';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import { isFunction } from 'lodash';
import { useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputSelectTypeOfReceiverRadio = ({
  countryConfig,
  information,
  setInformation,
  validation,
  setValidation,
  isDisabled,
  isEdit = false,
  onClick,
}) => {
  const { t } = useLang();
  const { isMobile, isTablet } = useDetectDevice();

  const { dmList, countryCode } = countryConfig || {};

  const validRef = useRef(null);

  const currentReceiverFistName = information[EDIT_RECEIVER_FISTNAME_NAME];
  const currentReceiverLastName = information[EDIT_RECEIVER_LASTNAME_NAME];

  const currentReceiverType =
    information[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME];
  const isReceiverOfIndividualType = currentReceiverType === 1;
  const isReceiverOfBusinessType = currentReceiverType === 2;

  const { isCreateBusinessReceiver, isCreateIndividualReceiver } =
    useReceiver();

  const checkReceiverOfBusinessTypeDisable = () => {
    const dmOfBank = dmList?.find((dm) => dm?.name === METHOD_BANK);
    const { currencies } = dmOfBank || {};
    return !dmOfBank || currencies?.some((c) => !c?.businessReceiver);
  };
  const isReceiverOfBusinessTypeDisable = checkReceiverOfBusinessTypeDisable();

  useEffect(() => {
    if (validation[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME]) {
      validRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [validation]);

  const handleOnChange = (value) => {
    if (currentReceiverType === value) return;

    const isReceiverOfIndividualType = value === 1;
    const isReceiverOfBusinessType = value === 2;

    let newInformation = {
      ...information,
      [EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME]: value,
    };

    if (isReceiverOfIndividualType) {
      newInformation = {
        ...newInformation,
        [EDIT_RECEIVER_FISTNAME_NAME]: currentReceiverFistName,
        [EDIT_RECEIVER_LASTNAME_NAME]: currentReceiverLastName,
        [EDIT_RECEIVER_FULLNAME_NAME]: getFullNameReceiver({
          isReceiverOfIndividualType,
          lastName: currentReceiverLastName,
          firstName: currentReceiverFistName,
          countryCode,
        }),
        [EDIT_RECEIVER_GENDER_NAME]: '',
        [EDIT_RECEIVER_RELATIONSHIP_NAME]: '',
      };
    }

    if (isReceiverOfBusinessType) {
      newInformation = {
        ...newInformation,
        [EDIT_RECEIVER_FISTNAME_NAME]: getFullNameReceiver({
          isReceiverOfBusinessType,
          lastName: currentReceiverLastName,
          firstName: currentReceiverFistName,
          countryCode,
        }),
        [EDIT_RECEIVER_LASTNAME_NAME]: '',
        [EDIT_RECEIVER_FULLNAME_NAME]: getFullNameReceiver({
          isReceiverOfBusinessType,
          lastName: currentReceiverLastName,
          firstName: currentReceiverFistName,
          countryCode,
        }),
        [EDIT_RECEIVER_GENDER_NAME]: BUSINESS_OF_RECEIVER_TYPE,
        [EDIT_RECEIVER_RELATIONSHIP_NAME]: '',
      };
    }

    console.log(
      `⭐ FormInputSelectTypeOfReceiverRadio 👉 handleOnChange ➡️ newInformation ↩`,
      newInformation,
    );
    setInformation(newInformation);

    const newValidation = {
      ...validation,
      [EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME]: '',
      [EDIT_RECEIVER_FISTNAME_NAME]: '',
      [EDIT_RECEIVER_LASTNAME_NAME]: '',
      [EDIT_RECEIVER_FULLNAME_NAME]: '',
      [EDIT_RECEIVER_GENDER_NAME]: '',
      [EDIT_RECEIVER_MOBILE_NAME]: '',
      [EDIT_RECEIVER_PHONE_NAME]: '',
      [EDIT_RECEIVER_RELATIONSHIP_NAME]: '',
    };
    setValidation(newValidation);
  };

  const renderFormCheckRadio1 = () => {
    if (isEdit && isReceiverOfBusinessType) return null;

    const handleFormCheckRadio = () => {
      if (isDisabled || isCreateIndividualReceiver) return;

      if (isCreateBusinessReceiver && isFunction(onClick)) {
        onClick(1);
        return;
      }

      handleOnChange(1);
    };

    const formCheckRadioClassName1 =
      EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME + '1';

    return (
      <FormCheckboxRadio
        name={EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME}
        className={`${formCheckRadioClassName1} ${
          isReceiverOfIndividualType && 'active'
        }`}
        label={t('label_individual_receiver')}
        isChecked={isReceiverOfIndividualType}
        onClick={handleFormCheckRadio}
      />
    );
  };

  const renderFormCheckRadio2 = () => {
    if (isEdit && isReceiverOfIndividualType) return null;

    const handleFormCheckRadio = () => {
      if (
        isDisabled ||
        isReceiverOfBusinessTypeDisable ||
        isCreateBusinessReceiver
      )
        return;

      if (isCreateIndividualReceiver && isFunction(onClick)) {
        onClick(2);
        return;
      }

      handleOnChange(2);
    };

    const formCheckRadioClassName2 =
      EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME + '2';

    return (
      <>
        <FormCheckboxRadio
          name={EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME}
          className={`${formCheckRadioClassName2} ${
            isReceiverOfBusinessType && 'active'
          }`}
          label={t('label_business_receiver')}
          isChecked={isReceiverOfBusinessType}
          onClick={handleFormCheckRadio}
          styles={{ marginRight: '4px' }}
          isDisabled={isReceiverOfBusinessTypeDisable}
        />
        {isReceiverOfBusinessTypeDisable && (
          <Tooltip>
            {isMobile || isTablet ? (
              <TooltipCommonMobile
                text={t('form_business_receiver_type_tooltip')}
                name={EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME}
                label={t(
                  EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD.label,
                )}
              />
            ) : (
              <TooltipCommon text={t('form_business_receiver_type_tooltip')} />
            )}
          </Tooltip>
        )}
      </>
    );
  };

  return (
    <FormGroupStyled>
      <FormLabel onClick={(e) => e.preventDefault()}>
        {t(EDIT_RECEIVER_PERSONAL_DETAILS_SELECT_TYPE_OF_RECEIVER_FIELD.label)}
        <span>*</span>
      </FormLabel>
      {renderFormCheckRadio1()}
      {renderFormCheckRadio2()}
      {Boolean(validation[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME]) && (
        <FormControlFeedback ref={validRef} hidden={false} type="invalid">
          {t(validation[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME])}
        </FormControlFeedback>
      )}
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  display: table;
  width: 100%;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
    clear: both;
  }
`;
const FormLabel = styled(Form.Label)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;

  display: block;
  color: var(--ds-c-grey-dark);
  margin-bottom: 16px;

  span {
    color: var(--c-required);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

const FormControlFeedback = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  color: var(--ds-c-red);
  position: absolute;
  margin-top: 4px;
  margin-bottom: 0px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

const Tooltip = styled.div`
  display: inline-flex;
`;

export default FormInputSelectTypeOfReceiverRadio;
